import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Custom hook to use the authentication context
 * @returns {Object} Auth context including currentUser and auth methods
 */
export function useAuth() {
  return useContext(AuthContext);
} 